import PropTypes from 'prop-types'
import { useState } from 'react'

import { FormModal, Snackbar } from '../../default'
import { CreatePlanGroupForm } from '../../forms'

/**
 * @description Displays a modal for creating a group of plans.
 * 
 * @author Maria Eduarda Franke
 * @param {boolean} open - Determines whether the modal is open or not.
 * @param {function} onClose - Callback function to close the modal.
 * @returns {JSX.Element} - Returns the JSX element of the CreatePlanGroupModal component.
 */
const CreatePlanGroupModal = ({ open, onClose }) => {

    const [showSnackbar, setShowSnackbar] = useState(false)

    const handleSnackbarClose = (_, reason) => {
        if (reason === 'clickaway') {
            return
        }
        setShowSnackbar(false)
    }

    return (
        <>
            <FormModal
                title='Criar Grupo de Planos'
                open={open} onClose={onClose}
            >
                <CreatePlanGroupForm onClose={onClose} setShowSnackbar={setShowSnackbar} />
            </FormModal>
            <Snackbar
                open={showSnackbar}
                onClose={handleSnackbarClose}
                vertical='bottom'
                horizontal='right'
                severity='success'
                variant='filled'
                message='Grupo de Planos criado com sucesso!'
                sx={{ mt: 1 }}
            />
        </>
    )

}

CreatePlanGroupModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
}

export default CreatePlanGroupModal